module.exports = __webpack_public_path__ + "img/silence-on-tourne.500fa063.jpg";